import { useState } from "react";

import { PinChecklistModal, PinChecklistsTable } from "modules/PendingChecklistsDashboard/components/PinChecklists/components";

import type { Checklist, PIN_TYPES } from "models";
import type { PinPendingChecklistsByPinType } from "modules/PendingChecklistsDashboard/components/PinChecklists/hooks";

type PinChecklistsProps = {
  checklists?: Checklist[];
  pinPendingChecklistsGroupedByPinType?: PinPendingChecklistsByPinType[];
};

export const PinChecklists = ({ checklists, pinPendingChecklistsGroupedByPinType }: PinChecklistsProps) => {
  const [selectedPinTypeForChecklistModal, setSelectedPinTypeForChecklistModal] = useState<PIN_TYPES | null>(null);

  const handleOpenPinPendingChecklist = (pinType: PIN_TYPES) => setSelectedPinTypeForChecklistModal(pinType);

  return (
    <>
      <PinChecklistsTable pinPendingChecklistsGroupedByPinType={pinPendingChecklistsGroupedByPinType} handleOpenPinPendingChecklist={handleOpenPinPendingChecklist} />
      <PinChecklistModal
        checklists={checklists}
        pinType={selectedPinTypeForChecklistModal}
        pinPendingChecklistsGroupedByPinType={pinPendingChecklistsGroupedByPinType}
        onClose={() => setSelectedPinTypeForChecklistModal(null)}
      />
    </>
  );
};
